import WorkComponent from "../../components/Works/Work";

function Work() {
  return (
    <>
        <WorkComponent />
    </>
  );
}

export default Work;
